import { Card, List, Badge, Skeleton } from "antd";
import Link from "next/link";

import { fetchFollowedCategories } from "~/redux/actions/app";

import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const FollowedCategoriesCard = () => {
  const user = useSelector((state) => state.user.user);
  const [categories, setCategories] = useState(null);

  useEffect(() => {
    if (user) {
      fetchFollowedCategories(user.id).then(setCategories);
    }
  }, []);

  return (
    <Card title="关注的版块">
      <Skeleton loading={!categories}>
        <List
          itemLayout="horizontal"
          dataSource={categories || []}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Badge count={item.followed_count} status="warning" />,
              ]}>
              <List.Item.Meta
                title={
                  <Link
                    legacyBehavior
                    href="/categories/[id]"
                    as={`/categories/${item.id}`}>
                    <a>{item.name}</a>
                  </Link>
                }
                description={item.description}
              />
            </List.Item>
          )}
        />
      </Skeleton>
    </Card>
  );
};

export default FollowedCategoriesCard;
